import { platforms } from "@/mocks/chigua";

export default function Entrance() {
  return (
    <section id="jieru" className="scroll-mt-20 bg-background-50 py-12 md:py-16">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold tracking-wide text-secondary-900">
              <i className="ri-dashboard-3-line" aria-hidden="true"></i>
              平台直达
            </p>
            <h2 className="font-heading mt-3 text-2xl font-bold text-foreground-950 md:text-3xl">
              多平台入口，一个页面全收齐
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-foreground-600">
            点击卡片即可跳转对应平台的公开官方页面，收藏本页等于把常去的讨论现场都装进一个入口。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {platforms.map((p) => (
            <a
              key={p.name}
              href={p.url}
              target="_blank"
              rel="noopener nofollow noreferrer"
              className="group flex flex-col rounded-2xl border border-background-200/80 bg-background-100 p-5 transition-all hover:-translate-y-1 hover:border-primary-300/70 hover:bg-background-50"
            >
              <div className="flex items-start justify-between">
                <span
                  className="flex h-12 w-12 items-center justify-center rounded-xl text-background-50"
                  style={{ backgroundColor: p.brand }}
                >
                  <i className={`${p.icon} text-2xl`} aria-hidden="true"></i>
                </span>
                <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs font-medium text-secondary-900">
                  {p.tag}
                </span>
              </div>
              <h3 className="mt-4 text-lg font-semibold text-foreground-950">{p.name}</h3>
              <p className="mt-1.5 flex-1 text-sm leading-relaxed text-foreground-600">{p.desc}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 transition-colors group-hover:text-primary-700">
                进入{p.name}
                <i className="ri-arrow-right-up-line transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}